import { PointsMaterial } from "three";
import { Shaders } from "../shaders";
import { PointCloudStyle } from "../../api";
import { mySetValuesImpl } from "./index";
export class PickingPointsMaterial extends PointsMaterial {
    constructor(parameters) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        super(parameters);
        this.objectId = (_a = parameters === null || parameters === void 0 ? void 0 : parameters.objectId) !== null && _a !== void 0 ? _a : 0;
        this.extraId = (_b = parameters === null || parameters === void 0 ? void 0 : parameters.extraId) !== null && _b !== void 0 ? _b : 0;
        this.userIdChannel = (_c = parameters === null || parameters === void 0 ? void 0 : parameters.userIdChannel) !== null && _c !== void 0 ? _c : false;
        this.style = (_d = parameters === null || parameters === void 0 ? void 0 : parameters.style) !== null && _d !== void 0 ? _d : PointCloudStyle.None;
        this.classificationColors = (_e = parameters === null || parameters === void 0 ? void 0 : parameters.classificationColors) !== null && _e !== void 0 ? _e : {};
        this.intensityColors = (_f = parameters === null || parameters === void 0 ? void 0 : parameters.intensityColors) !== null && _f !== void 0 ? _f : [
            { r: 0, g: 0, b: 0 },
            { r: 1, g: 1, b: 1 },
        ];
        this.gradientColors = (_g = parameters === null || parameters === void 0 ? void 0 : parameters.gradientColors) !== null && _g !== void 0 ? _g : [
            { r: 1, g: 0, b: 0 },
            { r: 0, g: 1, b: 0 },
        ];
        this.minGradient = { x: 0, y: 0, z: 0 };
        this.maxGradient = { x: 0, y: 0, z: 0 };
        this.brightness = (_h = parameters === null || parameters === void 0 ? void 0 : parameters.brightness) !== null && _h !== void 0 ? _h : 0.0;
        this.contrast = (_j = parameters === null || parameters === void 0 ? void 0 : parameters.contrast) !== null && _j !== void 0 ? _j : 1.0;
        this.gamma = (_k = parameters === null || parameters === void 0 ? void 0 : parameters.gamma) !== null && _k !== void 0 ? _k : 1.0;
        this.fillClassificationColors();
    }
    fillClassificationColors() {
        for (let id = 0; id <= 18; id++) {
            if (this.classificationColors[id] === undefined) {
                this.classificationColors[id] = {
                    base: { r: 1, g: 1, b: 1 },
                    show: false,
                };
            }
        }
    }
    setValues(parameters) {
        return mySetValuesImpl(this, parameters);
    }
    copy(material) {
        super.copy(material);
        if (material instanceof PickingPointsMaterial) {
            this.objectId = material.objectId;
            this.extraId = material.extraId;
        }
        return this;
    }
    onBeforeCompile(shader, renderer) {
        super.onBeforeCompile(shader, renderer);
        switch (this.style) {
            case PointCloudStyle.None:
                shader.vertexShader = Shaders.pointCloud.vertex(false, false, false, this.userIdChannel);
                shader.fragmentShader = Shaders.pointCloud.fragment(this.userIdChannel);
                break;
            case PointCloudStyle.IntensityColoring:
                shader.vertexShader = Shaders.pointCloudIntensity.vertex(true, false, false, this.userIdChannel);
                shader.fragmentShader = Shaders.pointCloudIntensity.fragment(this.intensityColors, this.userIdChannel);
                break;
            case PointCloudStyle.ClassificationColoring:
                shader.vertexShader = Shaders.pointCloudClassification.vertex(false, true, false, this.userIdChannel);
                shader.fragmentShader = Shaders.pointCloudClassification.fragment(this.classificationColors, this.userIdChannel);
                break;
            case PointCloudStyle.GradientColoring:
                shader.vertexShader = Shaders.pointCloudGradient.vertex(false, false, true, this.userIdChannel);
                shader.fragmentShader = Shaders.pointCloudGradient.fragment(this.gradientColors, this.userIdChannel);
                break;
        }
        shader.uniforms.objectId = {
            value: this.objectId,
        };
        shader.uniforms.extraId = {
            value: this.extraId,
        };
        shader.uniforms.minGradient = {
            value: this.minGradient,
        };
        shader.uniforms.maxGradient = {
            value: this.maxGradient,
        };
        shader.uniforms.brightness = {
            value: this.brightness,
        };
        shader.uniforms.contrast = {
            value: this.contrast,
        };
        shader.uniforms.gamma = {
            value: this.gamma,
        };
    }
    customProgramCacheKey() {
        return `:
        ${this.style}
        ${this.style === PointCloudStyle.ClassificationColoring ? JSON.stringify(this.classificationColors) : ""}
        ${this.style === PointCloudStyle.GradientColoring ? JSON.stringify(this.gradientColors) : ""}
        ${this.style === PointCloudStyle.IntensityColoring ? JSON.stringify(this.intensityColors) : ""}
        ${this.version}
        ${this.userIdChannel}
        `;
    }
}
